/**
 * RTK Query cache tag types. Used by providesTags / invalidatesTags so mutations
 * invalidate precisely (a single entity or a list) rather than nuking the cache.
 */
export const QUERY_KEYS = {
  USER: 'User',
  ROLE: 'Role',
  TENANT: 'Tenant',
  PARTNER: 'Partner',
  CUSTOMER: 'Customer',
  ASSET: 'Asset',
  GATEWAY: 'Gateway',
  TAG: 'Tag',
  TAG_HISTORY: 'TagHistory',
  ALARM: 'Alarm',
  ALARM_RULE: 'AlarmRule',
  DASHBOARD: 'Dashboard',
  SAVED_QUERY: 'SavedQuery',
  QUERY_RESULT: 'QueryResult',
  REPORT: 'Report',
  REPORT_RUN: 'ReportRun',
  CONNECTOR: 'Connector',
  SETTINGS: 'Settings',
  AUDIT: 'Audit',
} as const

export type QueryKey = (typeof QUERY_KEYS)[keyof typeof QUERY_KEYS]

/** Flat list of all tag types — registered with the RTK Query api at creation. */
export const ALL_QUERY_KEYS = Object.values(QUERY_KEYS)
